import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  private readonly msalService = inject(MsalService);

  protected signIn(): void {
    this.msalService.loginRedirect({
      scopes: [environment.entra.apiScope],
      redirectStartPage: `${window.location.origin}/home`,
    });
  }
}
